<template>
  <div
    v-show="!isMobile && isMenuOpen"
    class="header-space fixed left-0 top-0 z-menu h-full w-full backdrop-blur-sm"
    @click.stop="handleClose"
  >
    <div
      class="relative m-auto w-full max-w-[1600px] rounded-b-lg bg-white shadow-header desktop:w-[90%]"
      @click.stop
    >
      <LayoutHeaderMenu v-if="isTablet" />
      <LayoutCNMenuDesktopSolutions
        v-show="currentMenu === EnumCNMenuIndex.SOLUTIONS"
      />
      <LayoutCNMenuDesktopProducts
        v-show="currentMenu === EnumCNMenuIndex.PRODUCTS"
      />
      <LayoutCNMenuDesktopResources
        v-show="currentMenu === EnumCNMenuIndex.RESOURCES"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { EnumCNMenuIndex } from '@/stores/menuStore';

  const { isMobile, isTablet } = useScreen();
  const menuStore = useMenuStore();
  const { currentMenu, isMenuOpen } = storeToRefs(menuStore);

  const handleClose = (): void => {
    menuStore.HANDLE_CLOSE_MENU();
  };
</script>

<style lang="scss" scoped>
  .header-space {
    @apply pt-header-mobile-height tablet:pt-header-height;
  }
</style>
